module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new_guest_book"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'guest_book'
      }
    }
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.back))])]), _vm._v(" "), _c('div', {
    staticClass: "gue_box"
  }, [_c('div', {
    staticClass: "gue_box_user"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.showPage.guestName))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestName),
      expression: "book.guestName"
    }],
    staticClass: "sign_inp",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.book.guestName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestEmail),
      expression: "book.guestEmail"
    }],
    staticClass: "sign_inp",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.book.guestEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestEmail", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gue_box_ans mb10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestMessage),
      expression: "book.guestMessage"
    }],
    staticClass: "sign_txt",
    attrs: {
      "name": "",
      "cols": "",
      "rows": "",
      "placeholder": "留言內容"
    },
    domProps: {
      "value": (_vm.book.guestMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestMessage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.showPage.verificationCode))]), _vm._v(" "), _c('td', {
    staticClass: "vile"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": "6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"
    },
    on: {
      "verify": _vm.onVerify
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.showPage.leaveMessage))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-027d0791","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NewGuestBook.vue
// module id = 1193
// module chunks = 4